export const AUTH = `AUTH`;

export const SET_TOKEN_LOGIN = `${AUTH}/SET_TOKEN_LOGIN`;

export const LOGIN_REQUEST = `${AUTH}/LOGIN_REQUEST`;
export const LOGIN_SUCCESS = `${AUTH}/LOGIN_SUCCESS`;

export const LOGOUT_ACTION = `${AUTH}/LOGOUT_ACTION`;

export const TRIGGER_LOGIN = `${AUTH}/TRIGGER_LOGIN`;
export const TRIGGER_FORWARD_LOGIN = `${AUTH}/TRIGGER_FORWARD_LOGIN`;
export const FORWARD_LOGIN_SUCCESS = `${AUTH}/FORWARD_LOGIN_SUCCESS`;
export const FORWARD_LOGIN_FAIL = `${AUTH}/FORWARD_LOGIN_FAIL`;
export const SET_ACTIVE_PROFILE = `${AUTH}/SET_ACTIVE_PROFILE`;
export const GET_AGENT_INFO = `${AUTH}/GET_AGENT_INFO`;
export const SET_AGENT_INFO = `${AUTH}/SET_AGENT_INFO`;
export const GET_ROLES_AFTER_ACTIVE_PROFILE = `${AUTH}/GET_ROLES_AFTER_ACTIVE_PROFILE`;
export const SET_ROLES_AFTER_ACTIVE_PROFILE = `${AUTH}/SET_ROLES_AFTER_ACTIVE_PROFILE`;
export const SET_ALL_PROFILES_ROLES = `${AUTH}/SET_ALL_PROFILES_ROLES`;
export const GET_PERSONAL_DETAIL_AND_BUSINESS_INFORMATION = `${AUTH}/GET_PERSONAL_DETAIL_AND_BUSINESS_INFORMATION`;
export const SET_PERSONAL_DETAIL_INFORMATION = `${AUTH}/SET_PERSONAL_DETAIL_INFORMATION`;
export const SET_BUSINESS_INFORMATION = `${AUTH}/SET_BUSINESS_INFORMATION`;
export const GET_IS_HOUSEHOLD = `${AUTH}/GET_IS_HOUSEHOLD`;
export const SET_IS_HOUSEHOLD = `${AUTH}/SET_IS_HOUSEHOLD`;

// FORGET PASSWORD
export const AUTHENTICATION_FORGET_PASSWORD = `${AUTH}/AUTHENTICATION_FORGET_PASSWORD`;
export const SET_FORGET_PASSWORD_FACTORS = `${AUTH}/SET_FORGET_PASSWORD_FACTORS`;

export const SEND_OTP_FORGET_PASSWORD = `${AUTH}/SEND_OTP_FORGET_PASSWORD`;
export const SET_OTP_FORGET_PASSWORD = `${AUTH}/SET_OTP_FORGET_PASSWORD`;

export const VERIFY_OTP_FORGET_PASSWORD = `${AUTH}/VERIFY_OTP_FORGET_PASSWORD`;
export const RESET_PASSWORD = `${AUTH}/RESET_PASSWORD`;
